import { $themeConfig } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    // --- LÓGICA DE LEITURA ---
    isVerticalMenuCollapsed: (() => {
      const savedState = localStorage.getItem('verticalMenu.isCollapsed')

      // Se o usuário já salvou uma preferência ('true' ou 'false')
      if (savedState !== null) {
        return savedState === 'true' // Usa o valor salvo
      }

      // Se não houver nada salvo, usa o padrão do seu tema
      return $themeConfig.layout.menu.isCollapsed
    })(),
    // --- FIM DA LÓGICA ---
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },
  },
  actions: {},
}
